import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import marked from 'marked';
import MarkdownRenderer from '../../components/MarkdownRenderer';

class Tables extends Component {

    constructor(props) {
        super(props);

        this.state = {
          tables: ''
        }

        this.props.includeNav();
    }

    componentWillMount() {
        this.fetchMarkdown('tables');
    }

    fetchMarkdown = (file) => {
        const path = require(`./${file}.md`);
        fetch(path)
        .then(response => {
            return response.text()
        })
        .then(text => {
            this.setState({
                [file]: marked(text)
            })
        })
    }

    render() {

        return (
            <DocumentTitle
                title={'BCS Documentation - Tables'}>
                <section className="page" data-component="tables">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Tables</h1>
                            <p>Using the following format, you can easily create styled responsive tables.</p>
                            <div className="bcs-markdown">
                              <span className="text-italic">Note: Elements with</span> <code>{'.td-title'}</code><span className="text-italic"> class will only appear on xs and sm screens.</span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12 margin-b-3-xs margin-b-6-md">
                            <table className="bcs-table">
                                <thead>
                                    <tr className="row">
                                    <th className="col-xs-12 col-md-6">School</th>
                                    <th className="col-xs-6 col-md-4">Active Cohorts</th>
                                    <th className="col-xs-6 col-md-2">Active Classes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr role="button" className="row">
                                    <td className="col-xs-12 col-md-6">
                                        <div className="td-title">School</div>
                                        col 1 lorem ipsum dolor set amet
                                    </td>
                                    <td className="col-xs-6 col-md-4">
                                        <div className="td-title">Active Cohorts</div>
                                        col 2
                                    </td>
                                    <td className="col-xs-6 col-md-2">
                                        <div className="td-title">Active Classes</div>
                                        col 3
                                    </td>
                                    </tr>
                                    <tr role="button" className="row">
                                    <td className="col-xs-12 col-md-6">
                                        <div className="td-title">School</div>
                                        col 1
                                    </td>
                                    <td className="col-xs-6 col-md-4">
                                        <div className="td-title">Active Cohorts</div>
                                        col 2
                                    </td>
                                    <td className="col-xs-6 col-md-2">
                                        <div className="td-title">Active Classes</div>
                                        col 3
                                    </td>
                                    </tr>
                                    <tr role="button" className="row">
                                    <td className="col-xs-12 col-md-6">
                                        <div className="td-title">School</div>
                                        col 1
                                    </td>
                                    <td className="col-xs-6 col-md-4">
                                        <div className="td-title">Active Cohorts</div>
                                        col 2
                                    </td>
                                    <td className="col-xs-6 col-md-2">
                                        <div className="td-title">Active Classes</div>
                                        col 3
                                    </td>
                                    </tr>
                                    <tr role="button" className="row">
                                    <td className="col-xs-12 col-md-6">
                                        <div className="td-title">School</div>
                                        col 1
                                    </td>
                                    <td className="col-xs-6 col-md-4">
                                        <div className="td-title">Active Cohorts</div>
                                        col 2
                                    </td>
                                    <td className="col-xs-6 col-md-2">
                                        <div className="td-title">Active Classes</div>
                                        col 3
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-xs-12">
                          <MarkdownRenderer text={this.state.tables}/>
                        </div>
                    </div>

                </section>
            </DocumentTitle>
        )
    }
}

export default Tables;



// WEBPACK FOOTER //
// ./src/pages/Tables/index.js